import { createActions } from '../../createActions';

export const onchainTxsActions = createActions({});
